import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: "I was stuck at 15 clients for a year. The sales scripts in Volume 3 completely changed how I handle consultations. I'm now capped at 30 clients and raising my prices.",
    author: 'Mark D.',
    role: 'Independent PT'
  }, {
    quote: 'The onboarding templates saved me hours every week. My clients actually read the welcome packs now, and retention has never been better.',
    author: 'Chloe S.',
    role: 'Female Fat Loss Coach'
  }, {
    quote: 'I bought this just for the cancellation policy template, but the programming structures are gold. Worth 10x the price.',
    author: 'Tom H.',
    role: 'Strength & Conditioning'
  }, {
    quote: "Finally, a business resource that isn't just generic fluff. This is practical, usable stuff I implemented the same day.",
    author: 'Emma W.',
    role: 'Online Coach'
  }, {
    quote: "I used to dread the 'how much do you charge' question. The pricing calculator and sales frameworks gave me the confidence to charge what I'm worth.",
    author: 'Liam K.',
    role: 'Mobile PT'
  }, {
    quote: "If you're a new PT, don't even try to build your own forms. Just buy this. It will save you months of trial and error.",
    author: 'Sophie R.',
    role: 'Studio Owner'
  }];
  return <section className="bg-black py-16 md:py-24 border-y border-nero-border/20" data-id="element-276">
      <div className="max-w-6xl mx-auto px-4" data-id="element-277">
        <h2 className="text-white text-3xl md:text-4xl font-bold text-center mb-12 font-playfair" data-id="element-278">
          What Other Coaches Are Saying
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-279">
          {testimonials.map((t, idx) => <div key={idx} className="bg-nero-card border border-nero-border rounded-xl p-6 md:p-8" data-id="element-280">
              <div className="flex gap-1 mb-4" data-id="element-281">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-soft-gold text-soft-gold" data-id="element-282" />)}
              </div>
              <p className="text-white text-base md:text-lg italic mb-6 leading-relaxed" data-id="element-283">
                "{t.quote}"
              </p>
              <div data-id="element-284">
                <p className="text-soft-gold font-bold" data-id="element-285">{t.author}</p>
                <p className="text-secondary-text text-sm" data-id="element-286">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}